import React,{ useContext} from 'react';
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';

import { ThemeContext } from '../../contexts/ThemeContext';
//import { projectsData } from '../../data/projectsData'
import { HiArrowRight } from "react-icons/hi";

import './Projects.css'
import SingleProject from './SingleProject/SingleProject';

function Projects(props) {
	
    const { theme } = useContext(ThemeContext);

    
    const useStyles = makeStyles(() => ({
        viewAllBtn : {
            color: theme.tertiary, 
            backgroundColor: theme.primary,
            transition: 'color 0.2s',
            "&:hover": {
                color: theme.secondary, 
                backgroundColor: theme.primary,
            }
        },
        viewArr : {
            color: theme.tertiary, 
            backgroundColor: theme.secondary70,
            width: '40px',
            height: '40px',
            padding: '0.5rem',
            fontSize: '1.05rem',
            borderRadius: '50%',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            "&:hover": {
                color: theme.tertiary, 
                backgroundColor: theme.secondary,
            }
        },
    }));

    const classes = useStyles();

    return (
        <>
            {props.projets.length > 0 && (
                <div className="projects" id="projects" style={{backgroundColor: theme.secondary}}>
                    <div className="projects--header">
                        <h1 style={{color: theme.primary}}>Nos Projects et Réalisations</h1>
                    </div>
                    <div className="projects--body">
                        <div className="projects--bodyContainer">
                            {props.projets.slice(0, 4).map(project => (
                                <SingleProject
                                    theme={theme}
                                    key={project.id}
                                    id={project.id}
                                    name={project.Titre}
                                    desc={project.Description}
                                    tags={project.Tags}
                                    image={project.imageUrls[0]}
									images={project.imageUrls}
                                />
                            ))}
                        </div> 

                        {props.projets.length > 4 && (
                            <div className="projects--viewAll">
                                <Link to="/projects">
                                    <button 
									  className={classes.viewAllBtn} 
									  style={{
										color: 'white', /* Couleur du texte */
										
									  }}
									>
									 Autres
									  <HiArrowRight 
										className={classes.viewArr} 
										style={{ color: 'white', marginLeft: '5px' }} /* Icône en blanc et espace entre texte et icône */
									  />
									</button>

                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            )}

        </>
    )
}

export default Projects
